import styled, { keyframes } from "styled-components";


const expansion = () => keyframes`
 0% {
  box-shadow: 0 0 0 0px rgba(255,0,0,.5);
 }
 100% {
  box-shadow: 0 0 0 5px rgba(255,0,0,.5);
 }
`

export const FlorenzInput = styled.div`
  width: -webkit-fill-available;
  .input-container {
    background-color: ${({disabled}) => disabled ? "#CFD3DD" : "#F0F0FF"};
    border: none;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    min-width: 100px;
    position: relative;
    padding: 17px 20px;
    border-radius: 20px;
    border-bottom: 2px solid ${({disabled}) => disabled ? "#CFD3DD" : "#DADAFD"};    
    cursor: ${({disabled}) => disabled ? '' : 'text'};
    .icon-input-form {
      font-size: 14px;
      margin-right: 5px;
    }
    .icon-input-pass {
      margin-bottom: -5px;
      font-size: 14px;
      cursor: pointer;
    }
    .numeral {
      color: ${({disabled}) => disabled ? "##3E3E5B" : "#707582"};
      font-size: 13px;
      margin-right: 8px;
    }
    &:focus-within {
      .numeral {
        color: #2A28D6;
      }
    }
    input {
      border: none;
      background-color: transparent;
      width: 100%;
      font-family: "Nunito Sans Light";
      font-size: 20px;
      color: ${({disabled}) => disabled ? "#707582 important!" : "#1F1F52"};
      &:focus {
        outline: none;
        color: #2A28D6;
      }
      &::placeholder { 
        color: #707582;
        font-family: "Nunito Sans";
      }
      &::-webkit-scrollbar {
          height: 4px;
          width: 20px;
          margin: 0;
          opacity: .9;
          padding-bottom: 10px;
          cursor: pointer;
        }
        ::-webkit-scrollbar-track {
          min-height: 5px !important;
        }
        ::-webkit-scrollbar-thumb {
          min-height: 30px !important;
        }

    }
    input[type=number]::-webkit-inner-spin-button, 
    input[type=number]::-webkit-outer-spin-button { 
      -webkit-appearance: none; 
      margin: 0; 
    }
  }
`